//don't lint third party code
/* eslint-disable */ 

import * as Sentry from "@sentry/react";

const SENTRY_DSN = 'https://27020727688268a813f7ad65373c4812@o4509559991762944.ingest.us.sentry.io/4510032232579072';

const PROD_HOSTS = ['violerts.com', 'www.violerts.com'];
const QA_HOSTS = ['qa.violerts.com'];
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

const isProd = () => {
	return PROD_HOSTS.includes(window.location.hostname);
};

const isQa = () => {
	return QA_HOSTS.includes(window.location.hostname) || window.location.hostname.endsWith('violerts.com');
};

const isLocal = () => {
	return LOCAL_HOSTS.includes(window.location.hostname);
};

const isWidgetEnabled = () => {
	return isProd() || isQa() || isLocal();
};

export const initSentry = () => {
	if (isProd()) {
		Sentry.init({
			dsn: SENTRY_DSN,
			integrations: [],
			sendDefaultPii: true,
		});
	}
};

// The Google tag (gtag.js) itself is loaded and configured in public/index.html's <head>.
function gtag() {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(arguments);
}

export const trackPageView = (path) => {
	if (isProd() && path) {
		gtag('event', 'page_view', {
			page_location: path
		});
	}
}

export const initAdaWidget = () => {
	if (isWidgetEnabled()) {
		window._userway_config = window._userway_config || {};
		window._userway_config.position = 5;
		window._userway_config.color = '#355e3b';

		var script = document.createElement('script');
		script.src = `https://cdn.userway.org/widget.js`;
		script.setAttribute('data-account', 'Oa0aO0cYPl');
		script.setAttribute('data-position', '5'); // 5 = bottom left
		script.setAttribute('data-color', '#355e3b');
		document.head.appendChild(script);

		// Returns true once both UserWay elements exist and have been styled
		const styleUserWay = () => {
			const wrapper = document.querySelector('.userway_buttons_wrapper');
			if (wrapper) {
				wrapper.style.setProperty('position', 'fixed', 'important');
				wrapper.style.setProperty('bottom', '12px', 'important');
				wrapper.style.setProperty('left', '16px', 'important');
				wrapper.style.setProperty('right', 'auto', 'important');
				wrapper.style.setProperty('top', 'auto', 'important');
				wrapper.style.setProperty('margin', '0', 'important');
				wrapper.style.setProperty('padding', '0', 'important');
				wrapper.style.setProperty('transform', 'none', 'important');
			}
			const uai = document.querySelector('#userwayAccessibilityIcon, .uai');
			if (uai) {
				uai.style.setProperty('background', '#355e3b', 'important');
				uai.style.setProperty('background-color', '#355e3b', 'important');
				uai.style.setProperty('width', '50px', 'important');
				uai.style.setProperty('height', '50px', 'important');
				uai.style.setProperty('min-width', '50px', 'important');
				uai.style.setProperty('min-height', '50px', 'important');
				uai.style.setProperty('max-width', '50px', 'important');
				uai.style.setProperty('max-height', '50px', 'important');
				uai.style.setProperty('transform', 'none', 'important');
				uai.style.setProperty('border-radius', '50%', 'important');
				uai.style.setProperty('box-shadow', '0 4px 12px rgba(0, 0, 0, 0.15)', 'important');
			}
			return Boolean(wrapper && uai);
		};

		if (typeof window !== 'undefined' && typeof MutationObserver !== 'undefined' && document.body) {
			const observer = new MutationObserver(() => {
				if (styleUserWay()) {
					observer.disconnect();
				}
			});
			observer.observe(document.body, { childList: true, subtree: true });
			// Give up if the widget never loads
			setTimeout(() => observer.disconnect(), 15000);
		}
	} else {
		// console.log('userway ADA compliance widget disabled in dev mode.');
	}
};

export const initTidio = () => {
	if (isWidgetEnabled()) {
		var script = document.createElement('script');
		script.src = `//code.tidio.co/fec9n9hytaztzf6fp9afn2kcyzjqqani.js`;
		document.head.appendChild(script);
	} else {
		// console.log('Tidio disabled in dev mode.');
	}
};


export const initGoogleTagManager = () => {
	if (isProd()) {
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 
				'gtm.start': new Date().getTime(),
				event: 'gtm.js',
			});
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-M5GRXWP7');
	} else {
		// console.log('Google Tag Manager disabled in dev mode.');
	}
};

export const initThirdPartyScripts = () => {
	initAdaWidget();
	initGoogleTagManager();
	initTidio();
	initSentry();
}
